import * as i0 from "@angular/core";
var DataService = /** @class */ (function () {
    function DataService() {
    }
    Object.defineProperty(DataService.prototype, "setStaffInfo", {
        set: function (val) {
            this.staffInfo = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "getStaffInformation", {
        get: function () {
            return this.staffInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "setStaffPermission", {
        set: function (val) {
            this.staffInfo.access_attendance = val.access_attendance;
            this.staffInfo.access_apply = val.access_apply;
            this.staffInfo.access_omotenashi = val.access_apply;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "setIndividualSettings", {
        set: function (val) {
            this.individualSettings = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "getIndividualSettings", {
        get: function () {
            return this.individualSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "setHasSettings", {
        set: function (val) {
            this.hasSettings = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "getHasSettings", {
        get: function () {
            return this.hasSettings;
        },
        enumerable: true,
        configurable: true
    });
    DataService.ngInjectableDef = i0.defineInjectable({ factory: function DataService_Factory() { return new DataService(); }, token: DataService, providedIn: "root" });
    return DataService;
}());
export { DataService };
